import { isLocalBusinessMeta, isRecipeMeta, isWebPageMeta, isArticleMeta, isProductMeta, } from './genericMeta';
export function getOpenGraphArticle(_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description;
    return {
        og: {
            type: 'article',
            title: name,
            image: image || '',
            url: url || '',
            description: description,
        },
    };
}
export function getOpenGraphProduct(_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, ean = _a.ean, brand = _a.brand, _b = _a.category, category = _b === void 0 ? '' : _b;
    return {
        og: {
            type: 'product',
            title: name,
            url: url || '',
            image: image || '',
            description: description,
        },
        product: {
            ean: ean,
            brand: brand.name || '',
            product_link: url || '',
            category: category,
        },
    };
}
var getOpenGraphOpeningHours = function (openingHours) {
    return openingHours.map(function (h) { return ({
        day: h.dayOfWeek,
        start: h.opens,
        end: h.closes,
    }); });
};
export function getOpenGraphLocalBusiness(_a) {
    var name = _a.name, image = _a.image, url = _a.url, description = _a.description, email = _a.email, telephone = _a.telephone, faxNumber = _a.faxNumber, address = _a.address, openingHoursSpecification = _a.openingHoursSpecification;
    return {
        og: {
            type: 'business.business',
            title: name,
            image: image || '',
            url: url || '',
            description: description,
        },
        business: {
            contact_data: {
                street_address: address.streetAddress,
                locality: address.locality,
                postal_code: '',
                country_name: 'Finland',
                email: email,
                phone_number: telephone,
                fax_number: faxNumber,
                website: url || '',
            },
            hours: getOpenGraphOpeningHours(openingHoursSpecification),
        },
    };
}
export var mapMetaToOpenGraph = function (meta) {
    return isLocalBusinessMeta(meta) ? getOpenGraphLocalBusiness(meta) :
        isRecipeMeta(meta) ? getOpenGraphArticle(meta) :
            isArticleMeta(meta) ? getOpenGraphArticle(meta) :
                isWebPageMeta(meta) ? getOpenGraphArticle(meta) :
                    isProductMeta(meta) ? getOpenGraphProduct(meta) :
                        undefined;
};
